import React from 'react'
import { Card, CardHeader, Modal, IconButton, CardContent } from '@mui/material'
import { InputArea, InputButton } from '../../Simple'
import { BiX } from 'react-icons/bi'

import './stylesMObs.css'

export default function ModalObs({ show, onClose, value, onChange }) {
  return (
    <Modal open={show} onClose={onClose} className='contain-overlay-obs'>
      <Card className='contain-content-obs'>
        <CardHeader
          title='Observações'
          subheader='Adicione sua observação'
          sx={{ width: '100%', padding: '5px' }}
          action={
            <IconButton aria-label='settings'>
              <BiX className='icon-close-modal' onClick={() => onClose()} />
            </IconButton>
          }
        />
        <CardContent sx={{ width: '100%', padding: '5px' }}>
          <InputArea
            label='Observações'
            className='input-obs'
            rows={4}
            maxRows={4}
            fullWidth
            multiline
            placeholder='Digite aqui sua observação'
            value={value}
            onChange={e => {
              onChange(e.target.value)
            }}
          />

          <InputButton
            variant='contained'
            color='primary'
            sx={{ width: '100%', marginTop: '8px' }}
            onClick={() => {
              onClose()
            }}
          >
            Adicionar
          </InputButton>

          <InputButton
            variant='contained'
            color='error'
            sx={{ width: '100%', marginTop: '8px' }}
            onClick={() => {
              onChange('')
              onClose()
            }}
          >
            Remover
          </InputButton>
        </CardContent>
      </Card>
    </Modal>
  )
}
